export default function join(...fields) {
  return fields.join(' ');
}
